module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-date-picker', {
    attrs: {
      "locale": _vm.$t('message.locale')
    },
    model: {
      value: (_vm.item.date),
      callback: function($$v) {
        _vm.item.date = $$v
      },
      expression: "item.date"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogStart = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.start")) + ": " + _vm._s(_vm._f("moment")(_vm.item.start, "HH:mm a")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogEnd = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.end")) + ": " + _vm._s(_vm._f("moment")(_vm.item.end, "HH:mm a")))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "button": "",
      "right": "",
      "success": "",
      "absolute": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.saveItem()
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialogStart),
      callback: function($$v) {
        _vm.dialogStart = $$v
      },
      expression: "dialogStart"
    }
  }, [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-time-picker', {
    model: {
      value: (_vm.item.start),
      callback: function($$v) {
        _vm.item.start = $$v
      },
      expression: "item.start"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "primary text-xs-right",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogStart = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v("\n        OK\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialogEnd),
      callback: function($$v) {
        _vm.dialogEnd = $$v
      },
      expression: "dialogEnd"
    }
  }, [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-time-picker', {
    model: {
      value: (_vm.item.end),
      callback: function($$v) {
        _vm.item.end = $$v
      },
      expression: "item.end"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "primary text-xs-right",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogEnd = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v("\n        OK\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f47449","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Edit.vue
// module id = 237
// module chunks = 1